import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication/authentication.service";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, Params } from '@angular/router';
import {AccountSiteService} from '../account-site.service';
@Injectable()
export class AlreadyLoggedLoginComponentGuard  {

  constructor(private router: Router, private authenticationService: AuthenticationService,
              private accountSiteService: AccountSiteService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.routeHasTokenQueryParameter(route.queryParams)) {
      return true;
    }
    if (this.authenticationService.isUserLoggedIn() === false) {
      this.accountSiteService.goToLoginPage(true);
      return false;
    }
    if (this.authenticationService.doesUserHaveActiveSubscription()) {
      this.router.navigate(['/buildings']);
    } else {
      this.router.navigate(['/payment']);
    }
    return false;
  }

  private routeHasTokenQueryParameter(queryParams: Params): boolean {
    if (queryParams != null && queryParams['token'] != null) {
      return true;
    }
    return false;
  }
}
